/* eslint-disable react/prop-types */

/***
 * Simple widget showing a fixed value
 */
import classNames from 'classnames';
import {
  getFirstColumnValue,
  TestConditionalOperator,
  WidgetFormatValue
} from 'helpers/widgetHelper';
import PropTypes from 'prop-types';
import React from 'react';

export default function SingleValueWiget(props) {
  let bg = '';
  let tc = '';

  console.log(props.options);
  let value = getFirstColumnValue(props.data);
  let formattedValue = value;

  // format value
  if (props.options.format) {
    formattedValue = WidgetFormatValue(value, props.options.format);
  }

  // Do conditional styling
  if (props.options.conditionalStyling) {
    for (let i = 0; i < props.options.conditionalStyling.length; i++) {
      let conditionalStyle = props.options.conditionalStyling[i];
      if (
        TestConditionalOperator(
          value,
          conditionalStyle.value,
          conditionalStyle.operator
        )
      ) {
        bg = 'bg-' + conditionalStyle.colour;
        tc = 'text-light';
        break;
      }
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '8rem',
          height: '100%'
        }}
        className={classNames(
          'g-3 mb-3 display-1 fw-normal font-sans-serif text-center',
          bg,
          tc
        )}
      >
        {formattedValue}
        {/* <p className="display-1 fw-normal">{getFirstColumnValue(props.data)}</p> */}
        {/* <CountUp
          start={0}
          end={getFirstColumnValue(props.data)}
          duration={1.75}
          separator=","
        /> */}
      </div>
    </>
  );
}

SingleValueWiget.propTypes = {
  data: PropTypes.array
};
